export default __webpack_public_path__ + "static/media/cea3d6ca848a0b80af925d3cb599cbc5.svg";